import { ajax } from "discourse/lib/ajax";
import RestModel from "discourse/models/rest";

export default class AiLlm extends RestModel {
  createProperties() {
    return this.getProperties(
      "id",
      "display_name",
      "name",
      "provider",
      "tokenizer",
      "max_prompt_tokens",
      "max_output_tokens",
      "url",
      "ai_secret_id",
      "provider_params",
      "vision_enabled",
      "vision_mode",
      "vision_llm_model_id",
      "input_cost",
      "cached_input_cost",
      "cache_write_cost",
      "output_cost",
      "allowed_attachment_types"
    );
  }

  updateProperties() {
    const attrs = this.createProperties();
    attrs.id = this.id;
    attrs.llm_quotas = this.llm_quotas;
    return attrs;
  }

  async testConfig(llmConfig) {
    return await ajax("/admin/plugins/discourse-ai/ai-llms/test.json", {
      type: "POST",
      data: { ai_llm: llmConfig ?? this.createProperties() },
    });
  }
}
